'use client';

import { GridItem, Loader } from '@coolblue-development/freddy';
import removeItemFromWishlistTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/removeItemFromWishlistTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useClientLogger } from '@coolblue-development/next-config/client';
import { useWishlist } from '@coolblue-development/next-wishlist/client';
import WishlistRemoveProductButton from '@features/wishlist/components/ProductCard/WishlistRemoveProductButton';
import { ReactNode, useState } from 'react';

export default function WishlistProductCardWrapper({
  children,
  productId,
  allowRemoval = true,
  index,
  totalIndices
}: {
  children: ReactNode;
  productId: number;
  allowRemoval: boolean;
  index?: number;
  totalIndices?: number;
}) {
  const [show, setShow] = useState<boolean>(true);
  const [isRemoving, setIsRemoving] = useState<boolean>(false);
  const { removeProduct } = useWishlist();
  const clientLogger = useClientLogger();
  const { trackEvent } = useAnalytics();

  const trackRemoveWishlistProduct = () => {
    if (!index || !totalIndices) return;

    trackEvent(
      removeItemFromWishlistTrigger({
        index: index,
        total_indices: totalIndices,
        item_id: productId
      })
    );
  };
  const handleOnRemoveClick = () => {
    setIsRemoving(true);
    removeProduct(productId, { pathToRevalidate: 'wishlist' }).catch(error => {
      clientLogger.warning(`Product ${productId} could not be removed from wishlist`, error);
    });
    setTimeout(() => {
      setShow(false);
    }, 500);
    trackRemoveWishlistProduct();
  };

  return (
    show && (
      <GridItem
        column={{ xs: 'span 12', md: 'span 6', lg: 'span 3' }}
        sx={{ position: 'relative', paddingBottom: '1rem' }}
      >
        {isRemoving && <Loader />}
        {allowRemoval && <WishlistRemoveProductButton onRemoveClick={handleOnRemoveClick} />}
        {children}
      </GridItem>
    )
  );
}
